<template>
  <div class="bet-slip-tab-options mb-2 w-100">
    <div class="tab-inside">
      <div class="tab-item" @click="$emit('straightChoose')" :class="getClasses('straight')">
        {{ $t('BetSlip.Straight') }}
      </div>
      <div class="tab-item" @click="$emit('parlayChoose')" :class="getClasses('parlay')">
        {{ $t('BetSlip.Parlay') }}
      </div>
      <div class="tab-item" @click="$emit('teaserChoose')" :class="getClasses('teaser')">
        {{ $t('BetSlip.Teaser') }}
      </div>

      <div class="dropdown-wrapper" v-if="isDropdownIconShown()">
        <div class="dropdown-icon" @click="isOpen = !isOpen" :class="{ active: isOpen }">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="22" height="22" rx="4" fill="#fff" />
            <circle cx="11" cy="17" r="2" transform="rotate(90 11 17)" fill="#fff" />
            <circle cx="11" cy="11" r="2" transform="rotate(90 11 11)" fill="#fff" />
            <circle cx="11" cy="5" r="2" transform="rotate(90 11 5)" fill="#fff" />
          </svg>
        </div>

        <div class="options-dropdown-menu" :class="{ open: isOpen }">
          <div
            class="options-dropdown-item"
            @click="
              $emit('rrChoose');
              isOpen = false;
            "
            :class="getClasses('round_robin')"
          >
            {{ $t('BetSlip.RR') }}
          </div>
          <div
            class="options-dropdown-item"
            @click="
              $emit('ifWinChoose');
              isOpen = false;
            "
            :class="{
              active: selectedType === 'if_win' || selectedType === 'if_win_or_tie',
              'd-none': !(betTabs.includes('if_win') || betTabs.includes('if_win_or_tie')),
            }"
          >
            {{ $t('BetSlip.If Bet') }}
          </div>
          <div
            class="options-dropdown-item"
            @click="
              $emit('reverseChoose');
              isOpen = false;
            "
            :class="getClasses('reverse')"
          >
            {{ $t('BetSlip.Reverse') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BetSlipTabOptions',
  props: {
    selectedType: {
      required: true,
    },
    betTabs: {
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    getClasses(s) {
      return {
        active: this.selectedType === s,
        'd-none': !this.betTabs.includes(s),
      };
    },
    isDropdownIconShown() {
      const ar = ['if_win', 'if_win_or_tie', 'round_robin'];
      return this.betTabs.some(item => ar.indexOf(item) > -1);
    },
  },
};
</script>

<style lang="scss">
.bet-slip-tab-options {
  border-bottom: 1px solid #e8e8e8;

  .tab-inside {
    display: flex;
    align-items: center;
    height: 40px;
    font-size: 12px;
    font-weight: 500;

    .tab-item {
      width: 100%;
      text-align: center;
      color: var(--color);
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      padding: 0 2px;
      cursor: pointer;
      font-size: 14px;

      .kiosk & {
        color: #fff;
        @media (max-width: 776px) {
          color: var(--color) !important;
        }
      }

      &:hover {
        color: var(--color3);
      }

      &.active {
        color: var(--color3);
        font-weight: bold;
        position: relative;
        &::after {
          content: '';
          height: 3px;
          bottom: -2px;
          position: absolute;
          left: 0;
          right: 0;
          background: var(--color3);
        }
      }
    }
  }

  .dropdown-wrapper {
    position: relative;
    width: 40px;
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;

    .dropdown-icon {
      cursor: pointer;

      rect {
        fill: #fff;
      }
      circle {
        fill: #070a14;
      }

      &.active {
        rect {
          fill: #f4f4f4;
        }
        circle {
          fill: var(--color3);
        }
      }
    }

    .options-dropdown-menu {
      position: absolute;
      top: 30px;
      right: 0;
      background: #fff;
      width: 180px;
      box-shadow: 5px 5px 30px rgba(0, 0, 0, 0.25);
      border-radius: 5px;
      z-index: 88;
      overflow: hidden;
      transition: 0.3s ease all;
      display: none;

      &.open {
        display: block;
      }

      .options-dropdown-item {
        height: 30px;
        position: relative;
        line-height: 30px;
        padding-left: 17px;
        cursor: pointer;
        font-size: 14px;

        &.active {
          background: #f4f4f4;
          color: var(--color3);

          &::after {
            content: '';
            width: 2px;
            height: 100%;
            background: var(--color3);
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            border-radius: 1.5px;
          }
        }

        &:hover {
          color: var(--color3);
        }
      }
    }
  }
}
</style>
